// useApiHelper replaces the generic "HTTP Error: 404" text with the server's message for the
// statuses it explains, so callers must branch on the status, never on the message text.
export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export function apiErrorStatus(error: unknown): number | undefined {
  const status = (error as { status?: unknown } | null | undefined)?.status;
  return typeof status === "number" ? status : undefined;
}

export function isNotFound(error: unknown): boolean {
  return apiErrorStatus(error) === 404;
}
